import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: { // 要设置全局的访问的state对象
    // 要设置的初始属性值
    isCheckShow:localStorage.getItem('isCheckShow') || 0,
    isTabShow:localStorage.getItem('isTabShow') || 0,
    // isCheckShow:localStorage.getItem('isCheckShow'),
    isCheckBtn:localStorage.getItem('isCheckBtn') || 0,
  },
  getters:{ // 实时监听state值的变化（最新状态）
    checkShow(state){  // 承载变化的isCheckShow的值
      state.isCheckShow = localStorage.getItem('isCheckShow'); //从localStorage中读取状态
      return state.isCheckShow
    },
  },
  // 触发事件
  mutations: {
    /**
     * 自定义改变state初值的方法
    */
    changeCheckShow(state,status){
      if(status == 2){ // 公司
        localStorage.setItem('isCheckShow',1); //从localStorage中读取状态
      } else if(status == 1){ // 个体
        localStorage.setItem('isCheckShow',0); //从localStorage中读取状态
      }
      state.isCheckShow = localStorage.getItem('isCheckShow');
    },

    /**
     * 自定义改变state初值的方法-管理平台
    */
    changeTabShow(state,status){
      if(status == 1){ // 可进管理平台
        localStorage.setItem('isTabShow',1); //从localStorage中读取状态
      } else if(status == 0){ // 不可
        localStorage.setItem('isTabShow',0); //从localStorage中读取状态

      }
      state.isTabShow = localStorage.getItem('isTabShow');
    },

    /**
     * 检查是否有项目操作权限
    */
    changeCheckBtn(state,status){ 
      // debugger
      if(status == 0){ // 可操作
        localStorage.setItem('isCheckBtn',1); //从localStorage中读取状态
      } else if(status == 1){ // 不可
        localStorage.setItem('isCheckBtn',0); //从localStorage中读取状态

      }
      state.isCheckBtn = localStorage.getItem('isCheckBtn');
    },
  },
  actions: {},
  modules: {}
});
